/**
 * groupStorageGatewayRelation模块接口列表
 */
import $http from '../utils/http' // 导入http中创建的axios实例

const groupStorageGatewayRelation = {
  // 增加groupStorageGatewayRelation关联表
  createGroupStorageGatewayRelation (params) {
    return $http.post(`${global.API_URL}/sme/groupStoragegatewayRelationship/create`, params)
  },
  // 删除groupStorageGatewayRelation关联表
  deleteGroupStorageGatewayRelation (params) {
    return $http.post(`${global.API_URL}/sme/groupStoragegatewayRelationship/deleteByGroupIdAndStoragegatewayId`, params)
  }
}

export default groupStorageGatewayRelation



// WEBPACK FOOTER //
// ./src/api/groupStorageGatewayRelation.js